import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Mode, modePrettyNames, modes } from '../util/keys';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& > *': {
                margin: theme.spacing(1),
            },
        },
    }),
);

export type Props = {
    selectedMode: Mode,
    onSelected: (mode: Mode) => void
}

const ModeSelector: React.FC<Props> = ({ selectedMode = 'ionian', onSelected}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <ButtonGroup color="primary">{modes.map(mode =>
                <Button onClick={() => onSelected(mode)} variant={mode === selectedMode ? 'contained' : 'outlined'} key={mode}>{modePrettyNames[mode]}</Button>
            )}</ButtonGroup>
        </div>
    );
}

export default ModeSelector